export const YYYY_MM_DD = 'yyyy-MM-dd';
export const DD_MM_YYYY = 'dd/MM/yyyy';
export const EEEE_MMMM_DO_YYYY_HH_MM_SS_A = 'EEEE, MMMM do yyyy, HH:mm:ss a';
export const HH_MM = 'HH:mm';
export const HH_MM_DD_MM_YYYY = 'HH:mm dd/MM/yyyy';
export const DD_MM_YYYY_HH_MM = 'dd/MM/yyyy HH:mm';
export const DD__MM__YYYY_HH_MM = 'dd-MM-yyyy HH:mm';
export const ONE_SECOND_IN_MILLISECONDS = 1000;
export const ONE_MINUTE_IN_MILLISECONDS = 60000;
